<app-card [customClasses]="'bg-dashboard-card px-3 py-3'">
    <div class="p-4" *ngIf="!isLoading && test; else loadingOrError">
        <!-- Test Info Card -->
        <app-card [customClasses]="'shadow-md bg-back border rounded-3 p-4 mb-4'">
            <div class="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                <h4 class="text-prev fw-bold mb-0">
                    <i class="fas fa-file-alt me-2 text-prev"></i> {{ test.title }}
                </h4>
                <div class="d-flex align-items-center gap-2">
                    <button *ngIf="canAssign" class="btn btn-primary-custom px-3 py-2 fs-14" type="button" (click)="openAssign()">
                        <i class="fas fa-clipboard-check me-2"></i>
                        {{ 'ASSIGNMENTS.ASSIGN_THIS_TEST' | translate }}
                    </button>
                    <app-back-button [route]="backRoute" [label]="'BUTTONS.BACK' | translate"></app-back-button>
                </div>
            </div>

            <!-- Metadata Grid -->
            <div class="row gy-4 text-color lh-base">
                <div class="col-md-6">
                    <app-info-item icon="fas fa-align-left" [label]="'TEST_DETAIL.DESC_F' | translate"
                        [value]="test.description || '—'" />
                    <app-info-item icon="fas fa-cogs" [label]="'TEST_DETAIL.MODE_F' | translate"
                        [value]="translateTestMode(test.testMode)" />
                    <app-info-item icon="fas fa-list-ol" [label]="'TEST_DETAIL.QSTN_F' | translate"
                        [value]="test.questionsCount" />
                    <app-info-item icon="fas fa-star" [label]="'TEST_DETAIL.TOTALP_F' | translate"
                        [value]="test.totalPoints" />
                    <app-info-item icon="fas fa-check-circle" [label]="'TEST_DETAIL.PASS_F' | translate"
                        [value]="test.passingPercentage" />
                    <app-info-item icon="fas fa-clock" [label]="'TEST_DETAIL.TIME_F' | translate"
                        [value]="test.timeLimitMinutes + ' دقيقة'" />
                    <app-info-item icon="fas fa-redo" [label]="'TEST_DETAIL.ATTEMPT_F' | translate"
                        [value]="test.maxAttempts" />
                </div>
                <div class="col-md-6">
                    <app-info-item icon="fas fa-book" [label]="'TEST_DETAIL.SUB_F' | translate"
                        [value]="test.subjectName" />
                    <app-info-item icon="fas fa-calendar-plus" [label]="'TEST_DETAIL.SDATE_F' | translate"
                        [value]="test.startDate | localizedDate:'short'" />
                    <app-info-item icon="fas fa-calendar-times" [label]="'TEST_DETAIL.EDATE_F' | translate"
                        [value]="test.endDate | localizedDate:'short'" />
                    <app-info-item icon="fas fa-eye" [label]="'TEST_DETAIL.DISPR_F' | translate"
                        [value]="test.showResultsImmediately | yesNo" [status]="test.showResultsImmediately" />
                    <app-info-item icon="fas fa-history" [label]="'TEST_DETAIL.REVIEW_F' | translate"
                        [value]="test.allowReview | yesNo" [status]="test.allowReview" />
                </div>
            </div>
        </app-card>

        <app-card [customClasses]="'shadow-md bg-back border rounded-3 p-4'">
            <div *ngIf="!test.testQuestions?.length" class="text-color text-center py-4 opacity-75">
                <i class="fas fa-inbox me-2"></i>{{ 'TEST_DETAIL.NO_QUESTIONS' | translate }}
            </div>

            <!-- La garde porte sur la question entière, une seule fois : le
                 mapping du back renvoie `null` quand elle n'a pas été chargée,
                 et mieux vaut sauter la ligne que numéroter un énoncé vide. -->
            <div *ngFor="let testQ of test.testQuestions; let i = index" class="mb-4 p-1 p-sm-3 rounded">
              <ng-container *ngIf="testQ.question as question">
                <h5 class="text-color mb-2">
                    <i class="fas fa-question-circle text-prev px-2"></i> {{ i + 1 }}. <app-math-text [text]="question.title"></app-math-text>
                </h5>
                <p class="text-color mb-3" *ngIf="question.description"><app-math-text [text]="question.description"></app-math-text></p>

                <ul class="list-group" *ngIf="question.answerBanks?.length; else noAnswers">
                    <li class="list-group-item d-flex justify-content-between align-items-center bg-back"
                        *ngFor="let answer of question.answerBanks"
                        [ngClass]="answer.isCorrect ? 'list-group-item-success' : 'list-group-item-light'">
                        <span class="text-color">
                            <i class="px-1 fas"
                                [ngClass]="answer.isCorrect ? 'fa-check-circle text-success' : 'fa-times text-danger'"></i>
                            <app-math-text [text]="answer.content"></app-math-text>
                        </span>
                        <span *ngIf="answer.isCorrect" class="badge bg-success">✔</span>
                    </li>
                </ul>
                <ng-template #noAnswers>
                    <p class="text-color opacity-75 mb-0"><i class="fas fa-info-circle me-2"></i>{{ 'TEST_DETAIL.NO_ANSWERS' | translate }}</p>
                </ng-template>
              </ng-container>
            </div>
        </app-card>
    </div>

    <!-- Loading State -->
    <ng-template #loadingOrError>
        <div class="text-center my-5">
            <app-loader />
        </div>
    </ng-template>

</app-card>
